<template>
  <div class="lke-tab">
    <div>
      <div class="lke-top">
        <i class="el-icon-chat-line-square"></i>
        发布个人评论或心得
      </div>
      <el-input
        type="textarea"
        :autosize="{ minRows: 2, maxRows: 4 }"
        placeholder="请输入内容"
        v-model="value"
      >
      </el-input>
      <div class="lke-fot">
        <div class="lke-fot-l">
          <span>还可以输入{{ 180 - value.length }}字</span>
        </div>
        <div class="lke-fot-r">
          <span @click="addcomment()">发布</span>
        </div>
      </div>
    </div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="学员动态交流" name="0">
        <div class="lke-tabin" v-for="(list, index) in list" :key="index">
          <div class="lke-tab-l">
            <el-image
              style="width: 44px; height: 56px"
              :src="url + list.avatar"
              fit="fill"
            ></el-image>
          </div>
          <div class="lke-tab-r">
            <div class="lke-tab-r-top">
              <span>{{ list.name }}</span>
              <p>发表于：{{ list.createdAt | addtime }}</p>
            </div>
            <div class="lke-tab-r-mid">
              <p>
                {{ list.content }}
              </p>
            </div>
            <div class="lke-tab-r-fot" v-if="list.pinlun">
              <span
                @click="
                  list.pinlun = false;
                  list.dianpin = '';
                "
                >评论({{ list.parentComent.length }})</span
              >
            </div>
            <div v-else>
              <div>
                <div class="lke-top"></div>
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  placeholder="请输入评论"
                  v-model="list.dianpin"
                >
                </el-input>
                <div class="lke-fot">
                  <div class="lke-fot-l">
                    <span>还可以输入{{ 180 - list.dianpin.length }}字</span>
                  </div>
                  <div class="lke-fot-r">
                    <span @click="pinluncomment(list._id, list.dianpin)"
                      >评论</span
                    >
                  </div>
                </div>
                <div
                  style="margin-bottom: 5px"
                  v-for="(tab, index2) in list.parentComent"
                  :key="index2"
                >
                  <div class="lke-tab-r-top">
                    <span style="font-size: 14px; font-weight: none">{{
                      tab.name
                    }}</span>
                    <p>评论于：{{ tab.createdAt | addtime }}</p>
                  </div>
                  <div class="lke-tab-r-mid">
                    <p>
                      {{ tab.content }}
                    </p>
                  </div>
                  <div class="lke-tab-r-fot" v-if="list.pinlun"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-pagination
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :page-size="20"
          :total="total"
        >
        </el-pagination>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getcomment, addcomment } from "@/api/learnspace";
import { getImgUrl } from "@/utils/auth";
import moment from "moment";
export default {
  name: "dtjl",
  props: {},
  data() {
    return {
      activeName: "0",
      url: getImgUrl(),
      page: 1,
      value: "",
      total: 0,
      list: [],
    };
  },
  computed: {},
  filters: {
    addtime(val) {
      return moment(val).format("YYYY-MM-DD HH:mm:ss");
    },
    name(val1, val2) {
      if (val1[0]) {
        return val1[0].name;
      } else {
        return val2[0].name;
      }
    },
    url(val1, val2) {
      if (val1[0]) {
        if (val1[0].avatar) {
          return getImgUrl() + val1[0].avatar;
        }
      } else {
        if (val2[0].avatar) {
          return getImgUrl() + val2[0].avatar;
        }
      }
    },
  },
  created() {},
  mounted() {
    this.getcomment();
  },
  watch: {},
  methods: {
    addcomment() {
      if (!this.value) {
        this.$message({
          message: "请输入内容后发布",
          type: "warning",
        });
        return;
      }
      let obj = {
        content: this.value,
      };
      addcomment(obj).then((response) => {
        this.$message({
          message: "发布成功",
          type: "success",
        });
        this.value = "";
        this.page = 1;
        this.getcomment();
      });
    },

    pinluncomment(id, val) {
      if (!val) {
        this.$message({
          message: "请输入内容后发布",
          type: "warning",
        });
        return;
      }
      let obj = {
        content: val,
        parentCommentId: id,
      };
      addcomment(obj).then((response) => {
        this.$message({
          message: "评论成功",
          type: "success",
        });
        this.getcomment();
      });
    },

    getcomment() {
      let obj = {
        page: this.page,
        limit: 20,
      };
      getcomment(obj).then((response) => {
        let list = response.result;
        for (let index = 0; index < list.length; index++) {
          list[index].pinlun = true;
          list[index].dianpin = "";
        }
        this.list = list;
        this.total = count;
      });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getcomment();
    },
  },
  components: {},
};
</script>

<style>
.el-tabs__item.is-active {
  color: #2890f4;
}
.el-tabs__active-bar {
  background: #2890f4;
}
.el-tabs__item {
  font-size: 16px;
  font-weight: bold;
}
</style>

<style scoped>
.lke-top {
  padding: 10px 0;
  color: #2890f4;
  font-weight: bold;
}
.lke-top > i {
  font-size: 20px;
  padding-right: 5px;
}
.lke-fot {
  display: flex;
  justify-content: space-between;
  padding: 5px 10px;
}
.lke-fot-l > span {
  font-size: 12px;
}
.lke-fot-r {
  padding: 10px;
}
.lke-fot-r > span {
  color: #2890f4;
  cursor: pointer;
  font-weight: bold;
  letter-spacing: 2px;
}
.lke-tab {
  padding-top: 20px;
}
.lke-tabin {
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-bottom: 1px solid #ccc;
}
.lke-tab-l {
  padding: 2px;
  border: 1px solid #ccc;
  margin-right: 20px;
}
.lke-tab-r {
  flex: 1;
}
.lke-tab-r-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 0 10px 0;
}
.lke-tab-r-top > span {
  font-size: 16px;
  font-weight: bold;
  color: #2890f4;
}
.lke-tab-r-top > p {
  font-size: 12px;
  color: #a9a9a9;
}
.lke-tab-r-mid {
  font-size: 12px;
  line-height: 1.5;
}
.lke-tab-r-fot {
  display: flex;
  flex-direction: row-reverse;
  font-size: 14px;
  padding: 10px 0;
}
.lke-tab-r-fot > span {
  cursor: pointer;
}
.lke-tab-r-fot > span:hover {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/page/grzx/components/dtjl.vue